module.exports = __webpack_public_path__ + "static/media/HueLyewChin.a0700fa4.svg";